import React, { PropsWithChildren } from "react";
import FmCard, {
  FmCardProps,
} from "domains/file-manager/components/FileManagerV2/FmCard";
import Button from "domains/ui/components/Button";

import { Center, Text, VStack } from "@chakra-ui/react";

interface CardContainerProps extends Omit<FmCardProps<"model">, "type"> {
  cardWidth: number;
}

export default React.memo(function CardContainer({
  children,
  ...props
}: CardContainerProps) {
  const file = props.file;

  const isCopying = file.meta.status === "copying";
  const isNonTrained = file.meta.status !== "trained";
  const isTraining = file.meta.status === "training";
  const isFeatured = file.meta.tags.includes("sc:featured");
  const isCompact = props.cardWidth < 120;

  return (
    <Button
      internalLink={{
        pathname: "/models/[id]",
        query: { id: file.id },
      }}
      variant="unstyled"
      _hover={{
        opacity: 0.8,
      }}
    >
      <VStack align="flex-start" spacing={2}>
        <FmCard type="model" {...props}>
          {children}
        </FmCard>

        {(() => {
          if (isCompact) return null;
          if (isCopying) return <HighlightTag>Copying...</HighlightTag>;
          if (isTraining) return <HighlightTag>Training</HighlightTag>;
          if (isNonTrained) return <HighlightTag>Draft</HighlightTag>;
          if (isFeatured) return <HighlightTag>Featured</HighlightTag>;
        })()}

        {/* 
        <HStack flexWrap="wrap" overflow="hidden" w="full" h="24px">
          {file.meta.tags.map((tag) => (
            <Box key={tag}>
              <Tag
                fontSize="14px"
                fontWeight="400"
                whiteSpace="nowrap"
                bgColor="backgroundQuaternary.500"
              >
                {tagIdToLabel(tag)}
              </Tag>
            </Box>
          ))}
        </HStack> */}

        <Text
          overflow="hidden"
          w="full"
          color="textPrimary"
          textAlign="center"
          isTruncated
          size="body.bold.md"
        >
          {file.meta.name || "Untitled"}
        </Text>
      </VStack>
    </Button>
  );
});

function HighlightTag({ children }: PropsWithChildren) {
  return (
    <Center
      pos="absolute"
      zIndex="docked"
      top={3}
      right={3}
      h="28px"
      px={2}
      borderRadius="full"
      bgColor="white"
    >
      <Text color="black" size="body.bold.md">
        {children}
      </Text>
    </Center>
  );
}
